import type { Step } from '@/components/wizard/Step';

import type { IngestionPipelineWizardState } from './IngestionPipelineWizardState';
import { KafkaSchemaRegistryStep } from './steps/KafkaSchemaRegistryStep';
import { KafkaSecurityStep } from './steps/KafkaSecurityStep';
import { KafkaSettingsStep } from './steps/KafkaSettingsStep';
import { PartitioningStep } from './steps/PartitioningStep';
import { PipelineDetailsStep } from './steps/PipelineDetailsStep';
import { ReviewStep } from './steps/ReviewStep';
import { SourceStep } from './steps/SourceStep';

// Shared review step used by both S3/GCS and Kafka branches
const reviewStep: Step<IngestionPipelineWizardState> = {
  id: 'review',
  Component: ReviewStep,
};

export const IngestionPipelineCreationFlow: Step<IngestionPipelineWizardState> =
  {
    id: 'pipeline_details',
    Component: PipelineDetailsStep,
    next: [
      // Branch 0: S3/GCS path
      {
        id: 'source',
        Component: SourceStep,
        next: [
          {
            id: 'partitioning',
            Component: PartitioningStep,
            next: [reviewStep],
          },
        ],
      },
      // Branch 1: Kafka path
      {
        id: 'source_kafka',
        Component: SourceStep,
        next: [
          {
            id: 'kafka_security',
            Component: KafkaSecurityStep,
            next: [
              {
                id: 'kafka_schema_registry',
                Component: KafkaSchemaRegistryStep,
                next: [
                  {
                    id: 'kafka_settings',
                    Component: KafkaSettingsStep,
                    next: [reviewStep],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
